import { render, staticRenderFns } from "./FormDetalle.vue?vue&type=template&id=ba635656&"
import script from "./FormDetalle.vue?vue&type=script&lang=js&"
export * from "./FormDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports